import api from '@/infrastructure/api/axios';
import { customChargeSchema, serviceChargesResponseSchema, } from '../models/service-charge.schema';
// =============================================================================
// IMPLEMENTATION
// =============================================================================
export const serviceChargeRepository = {
    async getForService(serviceId) {
        const response = await api.get(`/services/${serviceId}/charges`);
        return serviceChargesResponseSchema.parse(response.data);
    },
    async attachTemplates(serviceId, chargeTemplateIds) {
        await api.post(`/services/${serviceId}/charges/templates`, { chargeTemplateIds });
    },
    async detachTemplate(serviceId, templateId) {
        await api.delete(`/services/${serviceId}/charges/templates/${templateId}`);
    },
    async createCustom(serviceId, dto) {
        const response = await api.post(`/services/${serviceId}/charges/custom`, dto);
        return customChargeSchema.parse(response.data);
    },
    async updateCustom(serviceId, chargeId, dto) {
        const response = await api.patch(`/services/${serviceId}/charges/custom/${chargeId}`, dto);
        return customChargeSchema.parse(response.data);
    },
    async deleteCustom(serviceId, chargeId) {
        await api.delete(`/services/${serviceId}/charges/custom/${chargeId}`);
    },
};
export default serviceChargeRepository;
